import { CartQuery as SourceCartQuery } from 'SourceQuery/Cart.query';

/** @namespace Pwa/Query/Cart/Query */
export class CartQuery extends SourceCartQuery {
    _getCartItemFields() {
        return [...super._getCartItemFields(), 'price_incl_tax'];
    }
}

export default new CartQuery();
